import React from "react";
import ReactModal from "react-modal";
import "./add-residual-modal.scss";
import { Formik } from "formik";
import { Card, Col, Form } from "react-bootstrap";
import SelectDropDown from "../../shared/drop-down/drop-down";
import Dropzone from "react-dropzone";
import { ResidualFileUpload } from "../../../api";
import * as yup from "yup";
const schema = yup.object({
    year: yup.string().trim().required("* Year is required"),
    month: yup.string().trim().required("* Month is required"),
});
class Addresidualmodal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            months: [
                { label: "January", value: 1 },
                { label: "February", value: 2 },
                { label: "March", value: 3 },
                { label: "April", value: 4 },
                { label: "May", value: 5 },
                { label: "June", value: 6 },
                { label: "July", value: 7 },
                { label: "August", value: 8 },
                { label: "September", value: 9 },
                { label: "October", value: 10 },
                { label: "November", value: 11 },
                { label: "December", value: 12 },
            ],
            formData: {
                year: "",
                month: "",
            },
            errors: [],
            years: [],
            fileUploadBinary: [],
            errorMessage: "",
            successMessage: "",
            showSuccesModal: false,
        };
        this._arrayBufferToBase64 = this._arrayBufferToBase64.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.handleAddResidual = this.handleAddResidual.bind(this);
    }

    handleAddResidual(evt) {
        const monthValue = this.state.months.find(
            (x) => x.value === this.state.formData.month,
        );
        const base64EncodedStr =
            this.state.fileUploadBinary[0] &&
            this.state.fileUploadBinary[0].binaryStr
                ? this.state.fileUploadBinary[0].binaryStr
                : undefined;
        const month = monthValue.label;
        const CurrentYear = this.state.formData.year;
        const organization_id = this.props.selectedOrganization_id;
        if (base64EncodedStr) {
            this.FileUpload(
                base64EncodedStr,
                month,
                CurrentYear,
                organization_id,
            );
        } else {
            this.setState({ errorMessage: "Please select a file to upload" });
        }
    }

    _arrayBufferToBase64(buffer) {
        var binary = "";
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    FileUpload = (file, month, CurrentYear, organization_id) => {
        var base64EncodedStr = this._arrayBufferToBase64(file);
        const data = {
            organization_id,
            base64EncodedStr,
            month,
            CurrentYear,
        };
        ResidualFileUpload(data)
            .then((response) => {
                if (response.success) {
                    this.setState({
                        showSuccesModal: true,
                        successMessage: "File uploaded successfully!",
                    });
                } else {
                    this.setState({ errorMessage: "Error while saving file!" });
                }
            })
            .catch((error) => console.log(error));
    };

    uploadFile(acceptedFiles) {
        let binaryFiles = [];
        let fileName = "";
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = (readerEvt) => {
            const binaryStr = reader.result;
            binaryFiles.push({
                name: fileName,
                binaryStr: binaryStr,
            });
            this.setState({ fileUploadBinary: binaryFiles, errorMessage: "" });
        };
        acceptedFiles.forEach((file) => {
            fileName = file.name;
            reader.readAsArrayBuffer(file);
        });
    }

    componentDidMount() {
        var max = new Date().getFullYear();
        var min = max - 15;
        var years = [];

        for (var i = max; i >= min; i--) {
            years.push({
                label: i,
                value: i,
            });
        }
        this.setState({ years: years });
    }
    render() {
        const {
            is_submitted,
            fileUploadBinary,
            years,
            months,
            formData,
            errors,
            showSuccesModal,
        } = this.state;
        return (
            <ReactModal
                isOpen={this.props.show}
                className="add-residue-modal Add-residual"
            >
                <div
                    onClick={() => this.props.handleClose()}
                    className="modal-cancel"
                >
                    <img src="/images/cancel.svg" />
                </div>
                <div className="modal-header">
                    <h4 className="text-left">Add residual</h4>
                </div>
                {!showSuccesModal && (
                    <>
                        <div className="modal-body">
                            <Formik
                                validationSchema={schema}
                                enableReinitialize
                                onSubmit={(e) => this.handleAddResidual(e)}
                                initialValues={formData}
                                initialErrors={errors}
                                validateOnBlur={false}
                                validateOnChange={is_submitted}
                                validate={(values) => {
                                    this.setState({ is_submitted: true });
                                }}
                            >
                                {({
                                    handleSubmit,
                                    handleChange,
                                    values,
                                    touched,
                                    errors,
                                }) => (
                                    <Form
                                        id="add-residual-form"
                                        onSubmit={handleSubmit}
                                    >
                                        <Form.Row>
                                            <Form.Group
                                                className="px-3 year-select"
                                                as={Col}
                                                xs={12}
                                                lg={4}
                                                controlId="year"
                                                required
                                            >
                                                <SelectDropDown
                                                    options={years}
                                                    name="year"
                                                    placeholder="Year"
                                                    value={formData.year}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        values["year"] =
                                                            selected.value;
                                                        formData["year"] =
                                                            selected.value;
                                                        errors.slug = "";
                                                    }}
                                                    touched={touched.year}
                                                    errors={errors.year}
                                                    is_submitted={is_submitted}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.year}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <Form.Group
                                                className="px-3 month-select"
                                                as={Col}
                                                xs={12}
                                                lg={8}
                                                controlId="month"
                                                required
                                            >
                                                <SelectDropDown
                                                    options={months}
                                                    name="month"
                                                    placeholder="Month"
                                                    value={formData.month}
                                                    handleChange={(
                                                        selected,
                                                    ) => {
                                                        values["month"] =
                                                            selected.value;
                                                        formData["month"] =
                                                            selected.value;
                                                        errors.month = "";
                                                    }}
                                                    touched={touched.month}
                                                    errors={errors.month}
                                                    is_submitted={is_submitted}
                                                />
                                                <Form.Control.Feedback
                                                    type="invalid"
                                                    className="text-capitalize"
                                                >
                                                    {errors.month}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                            <div className="add-resdi col-lg-12">
                                                <Dropzone
                                                    onDrop={(acceptedFiles) =>
                                                        this.uploadFile(
                                                            acceptedFiles,
                                                            this.props.month,
                                                            this.props
                                                                .selectedYear,
                                                        )
                                                    }
                                                    accept=".xlsx"
                                                >
                                                    {({
                                                        getRootProps,
                                                        getInputProps,
                                                    }) => (
                                                        <div
                                                            {...getRootProps({
                                                                className:
                                                                    "dropzone",
                                                            })}
                                                        >
                                                            <input
                                                                {...getInputProps()}
                                                            />
                                                            <p>
                                                                + Add residual
                                                            </p>
                                                        </div>
                                                    )}
                                                </Dropzone>
                                                {fileUploadBinary &&
                                                    fileUploadBinary[0] && (
                                                        <p>
                                                            {
                                                                fileUploadBinary[0]
                                                                    .name
                                                            }
                                                        </p>
                                                    )}
                                            </div>
                                        </Form.Row>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                        <p className="error-message">
                            {this.state.errorMessage}
                        </p>
                        <p className="success-message">
                            {this.state.successMessage}
                        </p>
                        <div className="modal-footer">
                            <button
                                form="add-residual-form"
                                type="submit"
                                className="btn confirm-button"
                            >
                                Add
                            </button>
                            <button
                                className="btn cancel-button"
                                onClick={() => this.props.handleClose()}
                            >
                                Cancel
                            </button>
                        </div>
                    </>
                )}
                {showSuccesModal && (
                    <>
                        <p>{this.state.successMessage}</p>
                        <div className="modal-body">
                            <div className="modal-footer">
                                <button
                                    className="btn confirm-button"
                                    onClick={() =>
                                        this.setState({
                                            showSuccesModal: false,
                                            successMessage: "",
                                            fileUploadBinary: [],
                                        })
                                    }
                                >
                                    Add more
                                </button>
                                <button
                                    className="btn cancel-button"
                                    onClick={() => this.props.handleClose()}
                                >
                                    close
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </ReactModal>
        );
    }
}

export default Addresidualmodal;
